
const routes = [
  {
    path: '/',
    redirect: 'home'
  },
  { // 홈
    path: '/home',
    name: 'Home',
    component: () => import('src/mobile/pages/Home')
  },
  { // 토너먼츠 홈
    path: '/tournaments',
    name: 'Tournaments',
    component: () => import('src/mobile/pages/Tournaments')
  },
  { // 토너먼츠 상세 (토너먼트, 개별이벤트)
    path: '/tournament/:idx',
    name: 'Tournament',
    component: () => import('src/mobile/pages/Tournament')
  },
  { // 타임라인
    path: '/timeline',
    name: 'Timeline',
    component: () => import('src/mobile/pages/Timeline')
  },
  { // 뉴스 (아티클 홈)
    path: '/news',
    name: 'News',
    component: () => import('src/mobile/pages/News')
  },
  { // 뉴스 카테고리
    path: '/news/cate/:idx',
    name: 'NewsCate',
    component: () => import('src/mobile/pages/NewsCate')
  },
  { // 아티클 키워드 검색
    path: '/article/search/:keyword',
    name: 'ArticleSearch',
    component: () => import('src/mobile/pages/ArticleSearch')
  },
  { // 아티클 에디터
    path: '/article/editor/:idx',
    name: 'ArticleEditor',
    component: () => import('src/mobile/pages/ArticleEditor')
  },
  { // 아티클 태그
    path: '/article/tag/:tag',
    name: 'ArticleTag',
    component: () => import('src/mobile/pages/ArticleTag')
  },
  { // 아티클 상세
    path: '/article/:idx',
    name: 'Article',
    component: () => import('src/mobile/pages/Article')
  },
  { // 라이브 이벤트
    path: '/events',
    name: 'Events',
    component: () => import('src/mobile/pages/Events')
  },
  { // 라이브 리포팅
    path: '/live/reporting/:idx',
    name: 'LiveReporting',
    component: () => import('src/mobile/pages/LiveReporting')
  },
  { // 라이브 리포팅 상세
    path: '/reporting/article/:idx',
    name: 'ReportingArticle',
    component: () => import('src/mobile/pages/ReportingArticle')
  },
  { // 인스타그램
    path: '/market',
    name: 'Market',
    component: () => import('src/mobile/pages/Market')
  },
  { // 인스타그램 상세
    path: '/market/article/:idx',
    name: 'MarketArticle',
    component: () => import('src/mobile/pages/MarketArticle')
  },
  { // 랭킹
    path: '/ranking',
    name: 'Ranking',
    component: () => import('src/mobile/pages/Ranking')
  },
  { // 갤러리
    path: '/gallery',
    name: 'Gallery',
    component: () => import('src/mobile/pages/Gallery')
  },
  { // 갤러리 검색
    path: '/gallery/search/:keyword',
    name: 'GallerySearch',
    component: () => import('src/mobile/pages/GallerySearch')
  },
  { // 갤러리 시리즈
    path: '/gallery/:series',
    name: 'GallerySeries',
    component: () => import('src/mobile/pages/GallerySeries')
  },
  { // 갤러리 시리즈 앨범
    path: '/gallery/:series/:album',
    name: 'GallerySeriesAlbum',
    component: () => import('src/mobile/pages/GallerySeriesAlbum')
  },
  { // poll
    path: '/poll',
		redirect: '/poll/quiz'
  },
  { // poll-issue
    path: '/news/cate/33',
		alias: '/poll/issue'
  },
  { // poll-quiz
    path: '/news/cate/54',
		alias: '/poll/quiz'
  },
  { // training
    path: '/news/cate/144',
		alias: '/training'
  },
  {
    path: '*',
    redirect: 'home'
  },
  {
    path: '/shop',
    beforeEnter() {location.href = 'https://www.gosty.co.kr/bluffcatch'},
  }
]

export default routes
